'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var variable_1 = require("./variable");
var Check;
(function (Check) {
    function isArray(value) {
        if (Array.isArray(value)) {
            return true;
        }
        if (variable_1.Variable.tag(value) === variable_1.Variable.TAG_ARRAY) {
            return true;
        }
        return false;
    }
    Check.isArray = isArray;
    function isAssignable(value) {
        if (!value) {
            return false;
        }
        if (typeof value !== 'object') {
            return false;
        }
        var valueTag = variable_1.Variable.tag(value);
        if (valueTag !== variable_1.Variable.TAG_OBJECT) {
            if (valueTag === variable_1.Variable.TAG_GLOBAL || valueTag === variable_1.Variable.TAG_WINDOW) {
                return true;
            }
            return false;
        }
        return isPlainObject(value);
    }
    Check.isAssignable = isAssignable;
    function isFalseLike(value) {
        return value === false || (("" + value).toLowerCase() === 'false');
    }
    Check.isFalseLike = isFalseLike;
    function isFinite(value) {
        return (typeof value === 'number') && Number.isFinite(value);
    }
    Check.isFinite = isFinite;
    function isFunction(value) {
        if (!value) {
            return false;
        }
        return ['[object AsyncFunction]', '[object Function]', '[object GeneratorFunction]', '[object Proxy]']
            .includes(variable_1.Variable.tag(value));
    }
    Check.isFunction = isFunction;
    function isGlobal(value) {
        var valueTag = variable_1.Variable.tag(value);
        return (valueTag === variable_1.Variable.TAG_GLOBAL) || (valueTag === variable_1.Variable.TAG_WINDOW);
    }
    Check.isGlobal = isGlobal;
    function isNil(value) {
        return isUndefined(value) || isNull(value);
    }
    Check.isNil = isNil;
    function isNull(value) {
        return value === null;
    }
    Check.isNull = isNull;
    function isNumber(value, onlyFinite) {
        if (onlyFinite === void 0) { onlyFinite = true; }
        if (onlyFinite) {
            return isFinite(value);
        }
        if (typeof value !== 'number') {
            return false;
        }
        return variable_1.Variable.tag(value) === variable_1.Variable.TAG_NUMBER;
    }
    Check.isNumber = isNumber;
    function isObjectLike(value) {
        return value !== null && typeof value === 'object';
    }
    Check.isObjectLike = isObjectLike;
    function isPlainObject(value) {
        if (!value) {
            return false;
        }
        if (typeof value !== 'object') {
            return false;
        }
        if (variable_1.Variable.tag(value) !== variable_1.Variable.TAG_OBJECT) {
            return false;
        }
        var proto = Object.getPrototypeOf(value);
        if (proto === null || proto === Object.prototype) {
            return true;
        }
        var ctor = Object.prototype.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return (typeof ctor === 'function')
            && (ctor instanceof ctor)
            && (Function.prototype.toString.call(ctor) === Function.prototype.call(Object));
    }
    Check.isPlainObject = isPlainObject;
    function isPrimitive(value) {
        return (value !== Object(value));
    }
    Check.isPrimitive = isPrimitive;
    function isPropertyExists(object, property) {
        return isObjectLike(object) && property in object;
    }
    Check.isPropertyExists = isPropertyExists;
    function isString(value) {
        return (typeof value === 'string') || (variable_1.Variable.tag(value) === variable_1.Variable.TAG_STRING);
    }
    Check.isString = isString;
    function isStringNumeric(value) {
        return /^[+-]?\d+(\.\d+)$/.test(value);
    }
    Check.isStringNumeric = isStringNumeric;
    function isTrueLike(value) {
        return value === true || (("" + value).toLowerCase() === 'true');
    }
    Check.isTrueLike = isTrueLike;
    function isUndefined(value) {
        return value === undefined;
    }
    Check.isUndefined = isUndefined;
    function isWindow(value) {
        return variable_1.Variable.tag(value) === variable_1.Variable.TAG_WINDOW;
    }
    Check.isWindow = isWindow;
})(Check = exports.Check || (exports.Check = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/check.ts
// module id = 0
// module chunks = 0 1